/* eslint-disable unicorn/no-this-assignment */
/* eslint-disable no-console */
import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import Request from '../../utils/request';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';
import Manipulator from '../../utils/dom/manipulator';
import Select from '../../components/Select';
import { Events } from '../../utils/dom/html-events';

const CLICK_EVENT = 'click';
const ENTER_KEY = '13';

class OnCourt {
	constructor() {
		this._wrapper = SelectorEngine.findOne('.lta-on-court-resources');
		if (!this._wrapper) {
			return;
		}
		this.initEvents();
		this.state = {
			serachInput: '',
			selectedAge: [],
			selectedProgramme: [],
			selectedGameSituation: [],
			selectedSessionPhase: [],
			selectedPlayerLevel: []
		};
	}

	initEvents() {
		// Events on Tabs Changes and Searches
		const current = this;
		const serachInputText = SelectorEngine.findOne('#search-on-court', this._wrapper);
		const searchButton = SelectorEngine.findOne('.on-court-search-btn', this._wrapper);
		const age = SelectorEngine.findOne('.lta-off-court-age-select', this._wrapper);
		const programme = SelectorEngine.findOne('.lta-off-court-programme-select', this._wrapper);
		const gameSituation = SelectorEngine.findOne('.lta-off-court-situation-select', this._wrapper);
		const sessionPhase = SelectorEngine.findOne('.lta-off-court-phase-select', this._wrapper);
		const playerLevel = SelectorEngine.findOne('.lta-off-court-level-select', this._wrapper);

		if (serachInputText) {
			EventHandler.on(serachInputText, 'change', (event) => {
				this.saveSerachInput(event);
			});
		}

		if (age) {
			this.ageElement = SelectorEngine.findOne('.js-lta-select', age);
			this.ageSelect = Select.getInstance(this.ageElement) || new Select(this.ageElement);
			EventHandler.on(this.ageSelect._selectNativeElement, 'change', (event) => {
				this.saveAge(event);
			});
		}

		if (programme) {
			this.programmeElement = SelectorEngine.findOne('.js-lta-select', programme);
			this.programmeSelect = Select.getInstance(this.programmeElement) || new Select(this.programmeElement);
			EventHandler.on(this.programmeSelect._selectNativeElement, 'change', (event) => {
				this.saveProgramme(event);
			});
		}

		if (gameSituation) {
			this.gameSituationElement = SelectorEngine.findOne('.js-lta-select', gameSituation);
			this.gameSituationSelect = Select.getInstance(this.gameSituationElement) || new Select(this.gameSituationElement);
			EventHandler.on(this.gameSituationSelect._selectNativeElement, 'change', (event) => {
				this.saveGameSituation(event);
			});
		}

		if (sessionPhase) {
			this.sessionPhaseElement = SelectorEngine.findOne('.js-lta-select', sessionPhase);
			this.sessionPhaseSelect = Select.getInstance(this.sessionPhaseElement) || new Select(this.sessionPhaseElement);
			EventHandler.on(this.sessionPhaseSelect._selectNativeElement, 'change', (event) => {
				this.saveSessionPhase(event);
			});
		}

		if (playerLevel) {
			this.playerLevelElement = SelectorEngine.findOne('.js-lta-select', playerLevel);
			this.playerLevelSelect = Select.getInstance(this.playerLevelElement) || new Select(this.playerLevelElement);
			EventHandler.on(this.playerLevelSelect._selectNativeElement, 'change', (event) => {
				this.savePlayerLevel(event);
			});
		}

		const applyFilter = SelectorEngine.findOne('.lta-on-court__btn', this._wrapper);
		const applyFilterMobile = SelectorEngine.findOne('.lta-on-court__btn-mobile', this._wrapper);
		const formElement = SelectorEngine.findOne('.js-on-court-search-form', this._wrapper);
		EventHandler.on(searchButton, CLICK_EVENT, () => {
			this.generateQueryString(formElement);
		});

		EventHandler.on(applyFilter, CLICK_EVENT, () => {
			this.generateQueryString(formElement);
		});

		EventHandler.on(applyFilterMobile, CLICK_EVENT, () => {
			this.generateQueryString(formElement);
		});

		EventHandler.on(serachInputText, Events.Keydown, (event) => {
			const key = event.keyCode || event.which;
			if (key == ENTER_KEY) {
				event.preventDefault();
				this.generateQueryString(formElement);
			}
		});

		const allBookmarkContainers = SelectorEngine.find('.lta-bookmark-container', this._wrapper);
		for (const container of allBookmarkContainers) {
			const addBookmarkButton = SelectorEngine.findOne('.lta-add-bookmark', container);
			const removeBookmarkButton = SelectorEngine.findOne('.lta-remove-bookmark', container);

			EventHandler.on(addBookmarkButton, CLICK_EVENT, (event) => {
				const pageId = Manipulator.getDataAttribute(addBookmarkButton, 'page-id');
				this.addBookmark(event, pageId, removeBookmarkButton);
			});

			EventHandler.on(removeBookmarkButton, CLICK_EVENT, (event) => {
				const pageId = Manipulator.getDataAttribute(removeBookmarkButton, 'page-id');
				this.removeBookmark(event, pageId, addBookmarkButton);
			});
		}
	}

	saveSerachInput(event) {
		const targetValue = event.target.value;
		this.state.serachInput = targetValue;
	}

	saveAge(event) {
		const selectedValues = [];
		// Loop through each option and add selected values to the array
		for (let index = 0; index < event.target.options.length; index++) {
			if (event.target.options[index].selected) {
				selectedValues.push(event.target.options[index].value);
			}
		}
		this.state.selectedAge = selectedValues;
	}

	saveProgramme(event) {
		const selectedValues = [];
		// Loop through each option and add selected values to the array
		for (let index = 0; index < event.target.options.length; index++) {
			if (event.target.options[index].selected) {
				selectedValues.push(event.target.options[index].value);
			}
		}
		this.state.selectedProgramme = selectedValues;
	}

	saveGameSituation(event) {
		const selectedValues = [];
		// Loop through each option and add selected values to the array
		for (let index = 0; index < event.target.options.length; index++) {
			if (event.target.options[index].selected) {
				selectedValues.push(event.target.options[index].value);
			}
		}
		this.state.selectedGameSituation = selectedValues;
	}

	saveSessionPhase(event) {
		const selectedValues = [];
		// Loop through each option and add selected values to the array
		for (let index = 0; index < event.target.options.length; index++) {
			if (event.target.options[index].selected) {
				selectedValues.push(event.target.options[index].value);
			}
		}
		this.state.selectedSessionPhase = selectedValues;
	}

	savePlayerLevel(event) {
		const selectedValues = [];
		// Loop through each option and add selected values to the array
		for (let index = 0; index < event.target.options.length; index++) {
			if (event.target.options[index].selected) {
				selectedValues.push(event.target.options[index].value);
			}
		}
		this.state.selectedPlayerLevel = selectedValues;
	}

	generateQueryString(formElement) {
		formElement.submit();
		// Initialize an empty array to store key-value pairs of the selected options
		// const queryParameters = [];

		// if (current.state.serachInput !== '') {
		// 	queryParameters.push('q=' + this.encodeParam(current.state.serachInput));
		// }

		// // Check if each array has data and add it to the query parameters
		// if (current.state.selectedAge.length > 0) {
		// 	queryParameters.push('age=' + this.encodeParam(current.state.selectedAge.join(',')));
		// }

		// if (current.state.selectedProgramme.length > 0) {
		// 	queryParameters.push('programme=' + this.encodeParam(current.state.selectedProgramme.join(',')));
		// }

		// if (current.state.selectedGameSituation.length > 0) {
		// 	queryParameters.push('situation=' + this.encodeParam(current.state.selectedGameSituation.join(',')));
		// }

		// if (current.state.selectedSessionPhase.length > 0) {
		// 	queryParameters.push('phase=' + this.encodeParam(current.state.selectedSessionPhase.join(',')));
		// }

		// if (current.state.selectedPlayerLevel.length > 0) {
		// 	queryParameters.push('level=' + this.encodeParam(current.state.selectedPlayerLevel.join(',')));
		// }

		// // Combine the query parameters into a single string
		// const queryString = queryParameters.join('&');

		// // Attach the query string to the current URL
		// const origin = window.location.origin;
		// const pathname = window.location.pathname;
		// const currentURL = origin + pathname;
		// const updatedURL = currentURL.includes('?') ? currentURL + '&' + queryString : currentURL + '?' + queryString;

		// // Update the window location
		// window.location.href = updatedURL;
	}

	encodeParam(value) {
		return encodeURIComponent(value.replace(/&/g, '&amp;'));
	}

	async addBookmark(event, pageId, element) {
		event.preventDefault();
		startLoadingAnimation(true);
		try {
			const apiUrl = '/api/coachdetails/bookmarkcontent';
			const responseData = await Request.post(apiUrl + '?pageId=' + pageId);

			const { Error, Response } = responseData;
			if (Error.errorCode == '00') {
				// For testing commented below code TODO: confirm approeach
				// event.target.classList.add('u-hidden');
				// element.classList.remove('u-hidden');
				window.location.reload();
			}
		} catch (error) {
			stopLoadingAnimation();
			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}

	async removeBookmark(event, pageId, element) {
		event.preventDefault();
		startLoadingAnimation(true);
		try {
			const apiUrl = '/api/coachdetails/unbookmarkcontent';
			const responseData = await Request.post(apiUrl + '?pageId=' + pageId);

			const { Error, Response } = responseData;
			if (Error.errorCode == '00') {
				// For testing commented below code TODO: confirm approeach
				// event.target.classList.add('u-hidden');
				// element.classList.remove('u-hidden');
				window.location.reload();
			}
		} catch (error) {
			stopLoadingAnimation();
			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}
}

const globalOnCourt = new OnCourt();
export default globalOnCourt;
